import {TipoTelefone} from './tipo-telefone';
import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class Telefone implements Construtor<Telefone> {

  public idTelefone: number;
  public numeroTelefone: string;
  public ramal: string;
  public tipoTelefone: TipoTelefone;
  public index: number;

  constructor(object?: any) {
    this.tipoTelefone = new TipoTelefone();
    if (object !== undefined) {

      if (object instanceof Telefone) {
        this.copyObject(object);
      } else if (object instanceof (TipoTelefone)) {
        this.tipoTelefone = object;
      } else {
        this.parseFromJson(object);
      }

    }
    return this;
  }

  get obterIdTelefone(): number {
    return this.idTelefone;
  }

  set IdTelefone(idTelefone: any) {
    this.idTelefone = idTelefone;
  }

  get obterNumeroTelefone(): string {
    return this.numeroTelefone;
  }

  set NumeroTelefone(numeroTelefone: any) {
    this.numeroTelefone = numeroTelefone;
  }

  get obterRamal(): string {
    return this.ramal;
  }

  set Ramal(ramal: any) {
    this.ramal = ramal;
  }

  get obterTipoTelefone(): TipoTelefone {
    return this.tipoTelefone;
  }

  set TipoTelefone(tipoTelefone: any) {
    this.tipoTelefone = new TipoTelefone(tipoTelefone);
  }

  copyObject(telefone: Telefone): void {
    this.idTelefone = telefone.obterIdTelefone;
    this.numeroTelefone = telefone.obterNumeroTelefone;
    this.ramal = telefone.obterRamal;
    this.TipoTelefone = telefone.tipoTelefone;
  }

  parseFromJson(telefone: any): void {
    this.IdTelefone = telefone.idTelefone;
    this.NumeroTelefone = telefone.numeroTelefone;
    this.Ramal = telefone.ramal;
    this.TipoTelefone = telefone.tipoTelefone;
  }

  getNewInstance(object?: any): Telefone {
    return new Telefone(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/telefone.ts